import { useState } from 'react';
import useUser from 'src/hook/data/useUser';
import { useIFrameModal } from 'src/hook/modal/useIFrameModal';
import { GetRazorSiteUrl, IconLocation, ImageLocation } from 'src/utils/URLUtils';
import styles from './PersonaliseSection.module.scss';
import { useTranslation } from 'react-i18next';

const PersonaliseSection = () => {
    const { open } = useIFrameModal();
    const { userInfo } = useUser();
    const [isVisible, setIsVisible] = useState(true);
    const isAddedWithinTwoWeeks = userInfo?.DateAdded &&
        new Date(userInfo.DateAdded) > new Date(Date.now() - 1000 * 60 * 60 * 24 * 14);
    const { t, i18n } = useTranslation();
    
    const handlePersonaliseClick = () => {
        open(GetRazorSiteUrl('onboarding/all-set',
            userInfo?.Token));
    }

    if (!isVisible || userInfo?.NativeLanguageCode || !isAddedWithinTwoWeeks) return null;

    return (
        <div className={styles.personaliseSection}>
            <div className={styles.content}>
                <h2 className='homeTitle'>Personalise WordUp</h2>
                <p dir={i18n.dir()} className='homeSubtitle'>
                    {t('Your life is unique. Choose what you like, or care about, to get the best out of WordUp.')}
                </p>
                <button className={styles.personaliseButton} onClick={handlePersonaliseClick}>
                    <img src={IconLocation('settings', true)}
                        alt="Settings" className='SmIcon' />
                    {t('Personalise')}
                </button>
            </div>
            <div className={styles.illustration}>
                <img
                    src={IconLocation('x')}
                    alt="Personalisation illustration"
                    width="20"
                    height="20"
                    onClick={() => setIsVisible(false)}
                    style={{ cursor: 'pointer' }}
                />
                <img
                    src={ImageLocation('Lexi/Personalise.png?w=1')}
                    alt="Personalisation illustration"
                    width="120"
                    height="120"
                />
            </div>
        </div>
    );
};

export default PersonaliseSection;
